import { useEffect } from "react";

let locks = 0;
let restore: { overflow: string; paddingRight: string } | null = null;

function lock(): void {
  locks += 1;
  if (locks > 1 || typeof document === "undefined") return;
  const body = document.body;
  restore = { overflow: body.style.overflow, paddingRight: body.style.paddingRight };
  const gap = window.innerWidth - document.documentElement.clientWidth;
  body.style.overflow = "hidden";
  if (gap > 0) body.style.paddingRight = `${gap}px`;
}

function unlock(): void {
  locks = Math.max(0, locks - 1);
  if (locks > 0 || restore === null || typeof document === "undefined") return;
  document.body.style.overflow = restore.overflow;
  document.body.style.paddingRight = restore.paddingRight;
  restore = null;
}

export function useScrollLock(): void {
  useEffect(() => {
    lock();
    return unlock;
  }, []);
}
